import React, { memo, useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
  IAttemptListItemResponseForWorkOrder,
  IAttemptListResponse,
} from "@miplatform/types";
import { Box } from "@mui/material";
import { KanbanCalendarMainBoard } from "./KanbanCalendarMainBoard/KanbanCalendarMainBoard";
import { KanbanCalendarTrays } from "./KanbanCalendarTrays/KanbanCalendarTrays";
import { OrderTypeFilter } from "./OrderTypeFilter/OrderTypeFilter";

export const KanbanCalendar = memo(
  ({ orderReasons, setSelectedOrder }: KanbanCalendarProps) => {
    const { classes } = useKanbanStyles();
    const [selectedTemplates, setSelectedTemplates] = useState<string[]>([]);

    return (
      <Box className={classes.kanbanContainer}>
        <OrderTypeFilter
          selectedTemplates={selectedTemplates}
          setSelectedTemplates={setSelectedTemplates}
        />
        <KanbanCalendarMainBoard
          selectedTemplates={selectedTemplates}
          orderReasons={orderReasons}
          setSelectedOrder={setSelectedOrder}
        />
        <KanbanCalendarTrays
          orderReasons={orderReasons}
          setSelectedOrder={setSelectedOrder}
        />
      </Box>
    );
  }
);

const useKanbanStyles = makeStyles()(() => ({
  kanbanContainer: {
    padding: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    position: "relative",
  },
}));

interface KanbanCalendarProps {
  orderReasons: {
    holdReasons: { value: string; label: string }[];
    rescheduleReasons: { value: string; label: string }[];
  };
  setSelectedOrder: (
    order:
      | IAttemptListResponse
      | IAttemptListItemResponseForWorkOrder
      | undefined
  ) => void;
}
